<!--template html-->
<template>
    <div v-if="collection">
        <div class="dropdown-menu card-message">
            <div class="gc-close-modal" @click="closePopupWithNoReload" v-if="!messageAdded">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                    <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13"></path>
                    <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1"></path>
                </svg>
            </div>
            <div class="mt-sign-card-form m-0" v-if="!messageAdded">
                <div class="mt-sign-control pt-3">
                    <div class="row">
                        <div class="col-6">
                            <label>First name</label>
                            <input type="text" v-model="message.FirstName" placeholder="First name" :class="{'group-card-error': !firstNameValid }" @keyup="firstNameCheck" />
                        </div>
                        <div class="col-6">
                            <label>Last name</label>
                            <input type="text" v-model="message.LastName" placeholder="Last name"  :class="{'group-card-error': !lastNameValid }" @keyup="lastNameCheck" />

                        </div>
                    </div>
                    <!-- row -->
                    </div>
                    <div class="mt-sign-control">
                        <label>Message</label>
                        <div class="mt-sign-textarea comment-div" ref="commentRefr" contenteditable="true" v-html="message.Message"  placeholder="Start typing" :class="{'group-card-error': !messageValid }" :maxlength="characterLimit" rows="5" @blur="updateHtml" @keyup="messageCheck" ></div>
                        <a href="javascript:void(0);" v-if="inspirationTexts.length > 0" class="like-suggestions" @click="showInspiration">Need inspiration?</a>
                        <div class="chars-left"><span>{{messageChars}}</span>/{{characterLimit}}</div>
                    </div>
                    <div class="mt-sign-control border-bottom-0 mb-0 pb-0">
                        <label>Add an image, video or GIF</label>
                        <div class="mt-3" id="previewPicDiv">
                            <div class="mt-card-image-preview position-relative d-inline-block">

                                <img v-if="message.ImageUrl === ''" id="preview-picture" src="https://grouptogether.blob.core.windows.net/images/no_pic.jpg" alt="Group Card Image"
                                     style="width: 125px; height:125px" />

                                <img v-else id="GroupCards[0].Pic-preview" :src="message.ImageUrl" alt="" style="width: 125px; height:125px" />

                                <a href="#" @click="deleteImage" id="gc-delete-preview-pic">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16">
                                        <path fill="#1e2437" fill-opacity="0.4"
                                              d="M 15 0 H 1 C 0.4 0 0 0.4 0 1 V 15 C 0 15.6 0.4 16 1 16 H 15 C 15.6 16 16 15.6 16 15 V 1 C 16 0.4 15.6 0 15 0 Z M 11.5 10.1 L 10.1 11.5 L 8 9.4 L 5.9 11.5 L 4.5 10.1 L 6.6 8 L 4.5 5.9 L 5.9 4.5 L 8 6.6 L 10.1 4.5 L 11.5 5.9 L 9.4 8 L 11.5 10.1 Z" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <!--<div class="d-flex justify-content-between" v-if="message.ImageUrl" id="gc-delete-prev-pic">
                <div class="mt-card-image-preview position-relative d-inline-block">
                    <img id="preview-picture" :src="message.ImageUrl" alt="Group Card Image" style="width: 125px; height:125px" />
                    <a href="javascript:void(0);" @click="deleteImage" id="gc-delete-preview-pic">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16" id="gc-delete-preview-pic-svg">
                            <path id="gc-delete-preview-pic-path" fill="#1e2437" fill-opacity="0.4" d="M 15 0 H 1 C 0.4 0 0 0.4 0 1 V 15 C 0 15.6 0.4 16 1 16 H 15 C 15.6 16 16 15.6 16 15 V 1 C 16 0.4 15.6 0 15 0 Z M 11.5 10.1 L 10.1 11.5 L 8 9.4 L 5.9 11.5 L 4.5 10.1 L 6.6 8 L 4.5 5.9 L 5.9 4.5 L 8 6.6 L 10.1 4.5 L 11.5 5.9 L 9.4 8 L 11.5 10.1 Z" />
                        </svg>
                    </a>
                </div>
            </div>-->
                        <div class="d-flex justify-content-between">
                            <div>
                                <button class="mt-browse-library" type="button" @click="showBrowseLibrary">Browse our library</button>
                            </div>
                            <div class="mt-upload-own">
                                <button>Upload your own</button>
                                <input type="file" id="file" class="message_upload_image_input" ref="AddMessageImage" @change="AddMessageImage" />
                            </div>
                        </div>
                        <div class="mt-3 justify-content-between">
                            <h5 class="verification-error update-phone-number-error" v-if="error">{{errorMessage}}</h5>
                        </div>

                        <div class="mt-3 justify-content-between">
                            <div>
                                <button class="theme-btn-lite" type="button" @click="saveMessage">Save message</button>
                            </div>
                        </div>
                        <div class="mt-3 justify-content-between">
                            <div>
                                <button class="theme-btn-dark" type="button" v-if="message.Id && (message.ContriId==='')" @click="confirm">Delete message</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Card message -->
                <div class="mt-comment-confirmation" v-else>
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 63 64" width="63" height="64">
                            <path fill="#e78970" d="M 34.4943 29.1529 C 29.3392 23.9979 23.3214 20.7954 18.7891 20.7954 C 16.8742 20.7954 15.2705 21.3869 14.1514 22.5061 C 13.2934 23.3641 12.756 24.4756 12.5435 25.7897 L 0.0702746 61.9435 C -0.0900491 62.4081 0.0289091 62.9235 0.376448 63.2709 C 0.621387 63.5158 0.949657 63.6471 1.28478 63.6471 C 1.42523 63.6471 1.56689 63.624 1.70409 63.5768 L 37.8005 51.1076 C 39.1452 50.8976 40.2852 50.3514 41.141 49.4955 C 43.0988 47.5378 43.388 44.2604 41.9554 40.2671 C 40.6372 36.5931 37.9875 32.6461 34.4943 29.1529 Z M 13.3371 31.7347 C 14.6552 35.4085 17.3049 39.3556 20.7981 42.8489 C 24.4018 46.4526 28.4268 49.1 32.0718 50.3683 L 21.2953 54.0909 C 19.0432 52.7735 16.7775 51.0002 14.7121 48.935 C 12.6436 46.8663 10.8685 44.5971 9.55053 42.3422 L 13.2733 31.5514 C 13.2947 31.6126 13.3151 31.6733 13.3371 31.7347 Z M 14.4519 56.4549 C 13.1095 55.458 11.8031 54.3272 10.5615 53.0856 C 9.31818 51.8422 8.18606 50.534 7.18815 49.1897 L 8.47888 45.4484 C 9.72644 47.2787 11.2231 49.0794 12.8954 50.7516 C 14.5652 52.4215 16.3633 53.9164 18.1911 55.1631 L 14.4519 56.4549 Z M 6.18981 52.0836 C 6.98201 53.0501 7.8357 53.9932 8.7448 54.9023 C 9.65261 55.8103 10.5943 56.6627 11.5594 57.454 L 3.35982 60.2864 L 6.18981 52.0836 Z M 39.3242 47.6787 C 38.8398 48.1631 38.1733 48.4651 37.3372 48.5817 C 37.3265 48.5829 37.3159 48.5842 37.3052 48.5857 C 37.0532 48.6194 36.7865 48.6371 36.5041 48.6371 H 36.5032 C 32.6858 48.6366 27.2342 45.6515 22.6148 41.0323 C 19.3841 37.8015 16.948 34.1915 15.7553 30.8671 C 14.6929 27.9058 14.7704 25.5204 15.9679 24.3229 C 16.6037 23.6871 17.5528 23.3647 18.7888 23.3647 C 22.6059 23.3647 28.0576 26.3498 32.6773 30.9696 C 35.908 34.2003 38.3441 37.8104 39.5367 41.1348 C 40.5994 44.096 40.522 46.4812 39.3242 47.6787 Z" />
                            <path fill="white" d="M 36.517 43.5841 C 36.5119 43.5841 36.5068 43.5841 36.5017 43.5843 C 34.8796 43.5825 30.6475 41.9191 26.1876 37.4594 C 25.686 36.9576 24.8726 36.9578 24.3709 37.4594 C 23.8692 37.961 23.8693 38.7745 24.3709 39.2761 C 28.4198 43.3249 33.409 46.153 36.5039 46.1535 L 36.5421 46.1532 C 37.2515 46.139 37.815 45.5523 37.8008 44.8431 C 37.7868 44.1425 37.2146 43.5841 36.517 43.5841 Z" />
                            <path fill="#ffc373" d="M 62.6235 24.1474 C 62.1219 23.6456 61.3085 23.6458 60.8068 24.1474 C 58.0367 26.9175 55.8107 26.8018 53.2343 26.6683 C 50.4958 26.5262 47.3916 26.3649 43.9314 29.8251 C 43.4298 30.3267 43.4298 31.1401 43.9314 31.6418 C 44.1823 31.8927 44.5111 32.0182 44.8398 32.0182 C 45.1685 32.0182 45.4973 31.8927 45.7481 31.6418 C 48.3998 28.99 50.578 29.1034 53.1011 29.2341 C 55.887 29.3787 59.0449 29.5426 62.6235 25.9641 C 63.1253 25.4624 63.1253 24.649 62.6235 24.1474 Z" />
                            <path fill="#ffec0f" d="M 23.6195 18.5169 C 24.329 18.5169 24.9042 17.9417 24.9042 17.2323 C 24.9042 13.3148 26.5595 11.8228 28.4762 10.0953 C 30.5132 8.25928 32.8222 6.17824 32.8221 1.28477 C 32.8221 0.575301 32.2469 0.00012207 31.5375 0.00012207 C 30.828 0.00012207 30.2528 0.575301 30.2528 1.28477 C 30.2528 5.03508 28.6324 6.49563 26.756 8.18682 C 24.6838 10.0547 22.335 12.1716 22.335 17.2323 C 22.3349 17.9418 22.9101 18.5169 23.6195 18.5169 Z" />
                            <path fill="#7fe2dc" d="M 49.7318 18.3818 H 49.7323 C 50.9378 18.3818 52.0714 17.9122 52.924 17.0597 C 54.6841 15.2996 54.6841 12.4358 52.924 10.6757 C 52.0714 9.82301 50.9378 9.35352 49.732 9.35352 C 48.5263 9.35352 47.3927 9.82301 46.5401 10.6757 C 45.6874 11.5282 45.2178 12.6618 45.2178 13.8677 C 45.2178 15.0735 45.6874 16.2071 46.54 17.0597 C 47.3925 17.9122 48.5261 18.3817 49.7318 18.3818 Z M 48.3568 12.4924 C 48.7241 12.1251 49.2125 11.9228 49.732 11.9228 C 50.2515 11.9228 50.7399 12.1251 51.1072 12.4924 C 51.8655 13.2507 51.8655 14.4846 51.1073 15.2428 C 50.7399 15.6103 50.2516 15.8125 49.7323 15.8125 H 49.7321 C 49.2125 15.8125 48.7241 15.6102 48.3567 15.2428 C 47.9894 14.8755 47.7871 14.3871 47.7871 13.8676 C 47.7871 13.3481 47.9894 12.8598 48.3568 12.4924 Z" />
                            <path fill="#7fe2dc" d="M 20.6748 9.18994 C 21.8806 9.18994 23.0141 8.72036 23.8668 7.86778 C 25.6267 6.10764 25.6267 3.24383 23.8667 1.48378 C 23.0141 0.631116 21.8805 0.161621 20.6747 0.161621 C 19.4689 0.161621 18.3354 0.631116 17.4827 1.48378 C 15.7226 3.24383 15.7226 6.10773 17.4827 7.86787 C 18.3354 8.72044 19.469 9.18994 20.6748 9.18994 Z M 19.2995 3.30052 C 19.6669 2.9332 20.1553 2.73091 20.6748 2.73091 C 21.1943 2.73091 21.6828 2.9332 22.0501 3.30052 C 22.8084 4.05881 22.8084 5.29275 22.05 6.05103 C 21.6828 6.41836 21.1944 6.62065 20.6749 6.62065 C 20.1554 6.62065 19.6669 6.41836 19.2995 6.05103 C 18.5412 5.29267 18.5412 4.05881 19.2995 3.30052 Z" />
                            <path fill="#7fe2dc" d="M 30.4753 17.2278 C 30.3386 17.3066 30.2198 17.4088 30.1228 17.5277 C 30.0044 17.6723 29.9223 17.8364 29.8764 18.0084 C 29.8476 18.1155 29.8324 18.2272 29.8325 18.3407 C 29.8326 18.4091 29.8381 18.4781 29.8495 18.5474 C 29.8739 18.698 29.9252 18.8451 30.0034 18.9809 C 30.0643 19.087 30.1392 19.1824 30.2252 19.2653 L 36.5941 25.6339 C 36.6762 25.7191 36.7705 25.7933 36.8753 25.8539 C 37.0114 25.9326 37.1589 25.9843 37.3098 26.009 C 37.3798 26.0206 37.4498 26.0263 37.519 26.0263 C 37.6311 26.0263 37.7414 26.0114 37.8473 25.9833 C 38.0227 25.9369 38.1903 25.8529 38.3371 25.7311 C 38.4524 25.636 38.5517 25.5203 38.6287 25.3876 C 38.6906 25.2816 38.7359 25.1685 38.7647 25.0523 L 41.0959 16.3519 C 41.1287 16.2382 41.1459 16.1192 41.1458 15.9981 V 15.998 C 41.1459 15.8408 41.117 15.6873 41.0627 15.5442 C 40.9962 15.3673 40.8936 15.2124 40.7656 15.0857 C 40.6412 14.9621 40.49 14.8626 40.318 14.7973 C 40.1741 14.7424 40.0198 14.713 39.8616 14.713 C 39.8606 14.7128 39.8604 14.7129 39.8599 14.713 C 39.7391 14.713 39.6205 14.7302 39.5071 14.7627 L 30.8065 17.094 C 30.6917 17.1226 30.5801 17.1672 30.4753 17.2278 Z M 38.0441 17.8147 L 36.8532 22.2595 L 33.5994 19.0057 L 38.0441 17.8147 Z" />
                            <path fill="#7fe2dc" d="M 56.6799 33.9061 H 51.1894 C 50.48 33.9061 49.9048 34.4812 49.9048 35.1908 V 40.6813 C 49.9048 41.3906 50.48 41.9659 51.1894 41.9659 H 56.6799 C 57.3894 41.9659 57.9646 41.3906 57.9646 40.6813 V 35.1908 C 57.9646 34.4812 57.3894 33.9061 56.6799 33.9061 Z M 55.3953 39.3967 H 52.4741 V 36.4755 H 55.3953 V 39.3967 Z" />
                        </svg>
                        <p>Your comment has been added successfully!</p>
                        <a href="javascript:void(0);" class="theme-btn-lite" @click="closePopup">Ok</a>
                    </div>
                </div>
                <!-- Card confirmation -->
            </div>
        <!-- Add message -->
    </div>
    <!-- Message option -->

    <GroupCardOptionsImageLibrary v-if="collection" @update-image="updateImageUrl" />
    <!-- GroupCardOptionsImageLibrary component -->

    <GroupCardOptionsInspirationText v-if="collection && inspirationTexts.length > 0" :inspirationTexts="inspirationTexts" @update-inspiration="updateText" />
    <!-- GroupCardOptionsInspirationText component -->
</template>
<!--template html-->
<!--script -->
<script>
    import GroupCardOptionsImageLibrary from './GroupCardOptionsImageLibrary.vue'
    import GroupCardOptionsInspirationText from './GroupCardOptionsInspirationText.vue'    

    export default {
        name: 'GroupCardOptionsAddMessage',
        components: {
            GroupCardOptionsImageLibrary,
            GroupCardOptionsInspirationText
        },
        props: {
            collection: String,
            characterLimit: Number,
            editMessageObj: Object,
            uploadedImageUrl: String
        },
        data: function () {
            return {
                messageChars: 0,
                fromValid: true,
                firstNameValid: true,
                lastNameValid: true,
                messageValid: true,
                inspirationTexts: [],
                message: {
                    Id: 0,
                    From: "",
                    FirstName:"",
                    LastName:"",
                    Message: "",
                    ImageUrl: "",
                    ContriId: ""
                },
                messageAdded: false,
                error: null,
                errorMessage: null,
                messageImageContainer:""
            }
        },
        watch: {
            uploadedImageUrl: function (val) {
                this.message.ImageUrl = val
            }
        },
        mounted: function () {
            this.messageChars = 0
            this.getInspirationText()

            window.parent.$(".gc-close-modal").click(function () {
                $(".dropdown-menu.card-message").removeClass("keep-open");
            });

            window.parent.setEditableDiv();
        },
        methods: {
            AddMessageImage() {
                var that = this
                let input = this.$refs.AddMessageImage
                this.messageImageContainer = "messageImageContainer";
                this.$emit('checkUserCropperContainer', this.messageImageContainer)
                //error if image size exceeds 5MB limit
                if (input.files[0].size > 5242880) {
                    $("#image_large_popup").modal()
                    $("#imageContainer").html($("#imageContainer").html())
                    return
                }
                if (input.files[0] == undefined)
                    return;
                if (input.files[0].type === "image/gif") {
                    if (window.FormData) {
                        var formdata = new FormData();
                        var messageGifUpload = input.files[0];


                        formdata.append("image", messageGifUpload);

                        $.ajax({
                            url: '/image/TransformImageGroupCardMessage',
                            type: "POST",
                            data: formdata,
                            processData: false,
                            contentType: false,
                            success: function (data) {
                                that.message.ImageUrl = data
                            },
                            error: function () {
                                console.log("Error has occurred.")
                            }
                        });
                    }
                }
                else {
                    $('#imageCropperContainer').modal('show');
                    let reader = new FileReader();
                    reader.addEventListener("load", function () {
                        window.src = reader.result;
                        $('.message_upload_image_input').val('');
                    }, false);
                    if (input.files[0]) {
                        reader.readAsDataURL(input.files[0]);
                    }
                }
              
            },
            //onFileChange(e) {
            //    this.error = null;
            //    this.errorMessage = "";
            //    var files = e.target.files || e.dataTransfer.files;
            //    if (!files.length)
            //        return;
            //    if (files[0].size > 5242880) {
            //        this.error = true;
            //        this.errorMessage = "The image you are trying to upload exceeds the maximum allowed limit. Try uploading an image with size lower than 5MB.";
            //    }
            //    else {
            //        this.submitImage(files[0]);
            //    }

            //},
            async submitImage(file) {
                let formData = new FormData();
                formData.append('file', file);
                const requestOptions = {
                    method: "POST",
                    body: formData
                };
                await fetch('/image/transformforgroupcard', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        //assign uploaded image to object
                        if (data.imageURL) {
                            this.message.ImageUrl = data.imageURL
                        }
                    })
                    .catch(err => console.log(err.message))
            },
            async getInspirationText() {
                await fetch('/api/collectionservices/getsuggestions?collection=' + this.collection)
                    .then((res) => res.json())
                    .then((data) => {
                        this.inspirationTexts = data
                    })
                    .catch(err => console.log(this.card))
            },
            openDropdown() {
                //refresh the message for new message
                this.message.Id = 0
                this.message.From = ""
                this.message.Message = ""
                this.message.FirstName = ""
                this.message.LastName = ""
                this.message.ImageUrl = ""
                this.messageChars=0
                if (!$(".card-message").hasClass("open show keep-open")) {
                    $(".dropdown-menu").removeClass("open show keep-open")
                    $(".card-message").addClass('open show keep-open');
                }
            },
            openDropdownWithObject(editMessageObj) {
               //initialize message object if editing existing message
                if (editMessageObj !== null) {
                    this.message.Id = editMessageObj.UniqueId
                    this.message.From = editMessageObj.Name
                    this.message.FirstName = editMessageObj.FirstName
                    this.message.LastName = editMessageObj.LastName
                    this.message.Message = editMessageObj.Message
                    this.message.ImageUrl = editMessageObj.ImageUrl
                    this.message.ContriId = editMessageObj.ContriId
                    this.messageChars = this.message.Message.length
                }

                if (!$(".card-message").hasClass("open show keep-open")) {
                    $(".dropdown-menu").removeClass("open show keep-open")
                    $(".card-message").addClass('open show keep-open');
                }
            },
            messageCheck(e) {
                //checks
                this.messageValid = true               
                this.messageChars = this.message.Message.length
            },
            updateHtml: function (e) {
                this.html = e.target.innerHTML;
                this.message.Message = this.html;
                this.messageValid = true
                this.messageChars = this.message.Message.length;
            },
            fromCheck() {
                //checks
                this.fromValid = true
            },
            firstNameCheck() {
                //checks
                this.firstNameValid = true
            },
            lastNameCheck() {
                //checks
                this.lastNameValid = true
            },
            deleteImage() {
                this.message.ImageUrl = null
            },
            showBrowseLibrary() {
                //show popup
                $("#group-card-browse-library").modal();
                $(".modal-backdrop").addClass("z-index-50");
            },
            updateImageUrl(imageUrl) {
                this.message.ImageUrl = imageUrl
            },
            updateText(text) {
                 
                this.message.Message =this.message.Message +" "+ text
            },
            showInspiration() {
                $("#group-card-inspiration").modal();
                $(".modal-backdrop").addClass("z-index-50");
            },
            closePopup() {
                this.refreshComponents()
                //hide modal
                $(".dropdown-menu").removeClass("open show keep-open")
                this.message = {
                    From: "",
                    FirstName: "",
                    LastName:"",
                    Message: "",
                    ImageUrl: ""
                }
                this.messageAdded = false
                location.reload()
            },
            refreshComponents() {
                this.$emit('refresh-components')
            },
            saveMessage() {
                //validate from
                if (!this.message.FirstName || this.message.FirstName === "") {
                    this.fromValid = false
                    this.firstNameValid = false
                }
                else {
                    this.firstNameValid = true
                }
                if (!this.message.LastName || this.message.LastName === "") {
                    this.fromValid = false
                    this.lastNameValid = false
                }
                else {
                    this.lastNameValid = true
                }
                //validate message
                if (!this.message.Message || this.message.Message === "" || this.message.Message === "<div><br></div>" || this.message.Message === "<br>") {
                    this.messageValid = false
                }
                else if (this.message.length > 1000) {
                    this.messageValid = false
                }

                

                if (this.firstNameValid && this.lastNameValid && this.messageValid) {
                    this.saveData()
                }
            },
            async saveData() {
                //creating sending object
                let messageObj = {
                    Collection: this.collection,
                    Name: this.message.From,
                    FirstName: this.message.FirstName,
                    LastName: this.message.LastName,
                    Message: this.message.Message,
                    ImageUrl: this.message.ImageUrl,
                    Id: this.message.Id
                }
                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(messageObj)
                };
                await fetch('/api/collectionservices/addgroupcardmessage', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            this.messageAdded = true
                        }
                    })
                    .catch(err => console.log(err.message))
            },
            confirm() {
                $('#confirmMessage').modal();
            },
            async confirmDelete() {
                //creating sending object
                let messageObj = {
                    Collection: this.collection,
                    Id: this.message.Id
                }
                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(messageObj)
                };
                await fetch('/api/collectionservices/DeleteGroupCardMessage', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            location.reload();
                        }
                        else {
                            $('#confirmMessage').modal('hide');
                            $('#ErrorModalGC').modal();
                        }
                    })
                    .catch(err => {
                        console.log(err.message)
                        $('#confirmMessage').modal('hide');
                        $('#ErrorModalGC').modal();
                    })
            },
            closePopupWithNoReload() {
                this.refreshComponents()
                //hide modal
                $(".dropdown-menu").removeClass("open show")
                this.message = {
                    From: "",
                    Message: "",
                    ImageUrl: ""
                }
                this.messageAdded = false
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
    .group-card-error {
        border: red 1px solid;
    }
</style>